import {Presenter} from '../../../Support/with_presenter';
import {ReportService} from '../../../Network/ReportService';
import {loadingResponse, NetworkResult} from '../../../Network/NetworkResult';
import {Report} from '../../../Models/Report';

export class ReportIndexPresenter implements Presenter {
    public _reports: NetworkResult<Report[]> = loadingResponse();

    public get reports(): NetworkResult<Report[]> {
        if (this._reports.status === 'success') {
            const data = [...this._reports.data].sort((p, c) => {
                //Sort by latestSnippetAt (nullable)
                if (!p.latestSnippetAt) {
                    return -1;
                }
                if (!c.latestSnippetAt) {
                    return 1;
                }
                return new Date(p.latestSnippetAt).getTime() - new Date(c.latestSnippetAt).getTime();
            });
            return {
                ...this._reports,
                data: data,
            };
        }

        return this._reports;
    }

    constructor(private reportService: ReportService) {}

    public async mount(): Promise<void> {
        this._reports = await this.reportService.all();
    }

    public unmount(): void {
        /* Noop */
    }
}
